module.exports = {
	"mobile-portrait": "320px",
	"mobile-landscape": "480px",
	"mobile-large-landscape": "568px",
	"tablet-portrait": "768px",
	"tablet-landscape": "1024px",
	"desktop": "1025px",
	"phablet-portrait": "414px",
	"phablet-landscape": "736px"
};


//////////////////
// WEBPACK FOOTER
// ./~/bunsen/json/breakpoints.json
// module id = 2634
// module chunks = 64